import React, { Component } from 'react'
import { connect } from 'react-redux'

import BoxButton from '../components/Layout/BoxButton'
import ButtonStrip from '../components/Layout/ButtonStrip'
import history from '../utils/history'

//actions
import { getSolicitud as getSolicitudOS } from '../actions/otrosi'
import { getSolicitud as getSolicitudServicioOT, registerCancelacion as cancelarServicioOT } from '../actions/solicitudservicioot'
import { getSolicitud as getSolicitudServicio, registerCancelacion as cancelarServicio } from '../actions/solicitudservicio'
import { getSolicitud as getSolicitudBienes, updateSolicitudBI, registerCancelacion as cancelarBienes } from "../actions/solicitudbi"
//----



import GeneralServicioOT from '../components/SolicitudServicioOT/General'
import AprobacionesServicioOT from '../components/SolicitudServicioOT/Aprobaciones'
import DocumentosServicioOT from '../components/SolicitudServicioOT/Documentos'
import CancelacionServicioOT from '../components/SolicitudServicioOT/Cancelacion'

import GeneralServicio from '../components/SolicitudServicio/General'
import AprobacionesServicio from '../components/SolicitudServicio/Aprobaciones'
import DocumentosServicio from '../components/SolicitudServicio/Documentos'
import CancelacionServicio from '../components/SolicitudServicio/Cancelacion'

import GeneralBienes from '../components/SolicitudBI/General'
import AprobacionesBienes from '../components/SolicitudBI/Aprobaciones'
import DocumentosBienes from '../components/SolicitudBI/Documentos'
import CancelacionBienes from '../components/SolicitudBI/Cancelacion'



import { 
    showModalConfirmarAccion,
    getParameterByName
} from '../actions/common'

import { isAllowedToViewComponent } from '../utils/helpers'

class Otrosi extends Component {
    
	constructor(props) {
        super(props)
		this.state = {
            tabs: [{component: null}],
            selected: 0,
            load: true
        } 
    }

    componentWillMount() {
        if (this.props.match.params.id) {            
            this.props.getSolicitudOS(this.props.match.params.id) 
            this.props.getParameterByName('DIVISAS')           
        } else {
            history.push(window.FOLDER + '/solicitudes/abiertas')
        }        
    }

    componentWillReceiveProps(nextProps) { 
        

        switch (nextProps.tipo_solicitud) {

            case 1:

                if (this.props.match.params.id) {
                    this.props.getSolicitudServicio(this.props.match.params.id)
                } else {
                    history.push(window.FOLDER + '/solicitudes/abiertas')
                }

                this.setState({
                    tabs: [
                        { id: 0, caption: 'Solicitud', component: <GeneralServicio />, estado: 0 },
                        { id: 1, caption: 'Aprobaciones', component: <AprobacionesServicio />, estado: 0 },
                        { id: 2, caption: 'Documentos', component: <DocumentosServicio />, estado: 4 },
                        { id: 3, caption: 'Cancelación', component: <CancelacionServicio />, estado: 4 },
                    ],
                    selected: this.state.selected,
                    load: true,
                    cancelarOtrosi: this.props.cancelarServicio
                })

            break




            case 3:

                if (this.props.match.params.id) {
                    this.props.getSolicitudServicioOT(this.props.match.params.id)
                } else {
                    history.push(window.FOLDER + '/solicitudes/abiertas')
                }

                this.setState({
                    tabs: [
                        { id: 0, caption: 'Solicitud', component: <GeneralServicioOT />, estado: 0 },
                        { id: 1, caption: 'Aprobaciones', component: <AprobacionesServicioOT />, estado: 0 },
                        { id: 2, caption: 'Documentos', component: <DocumentosServicioOT />, estado: 4 },
                        { id: 3, caption: 'Cancelación', component: <CancelacionServicioOT />, estado: 4 },
                    ],
                    selected: this.state.selected,
                    load: true,
                    cancelarOtrosi: this.props.cancelarServicioOT
                })

            break

            case 6:
            case 7:
            if (this.props.match.params.id) {
                this.props.getSolicitudBienes(this.props.match.params.id)
            } else {
                history.push(window.FOLDER + '/solicitudes/abiertas')
            }

            this.setState({
                tabs: [
                    { id: 0, caption: 'Solicitud', component: <GeneralBienes />, estado: 0 },
                    { id: 1, caption: 'Aprobaciones', component: <AprobacionesBienes />, estado: 2 },
                    { id: 2, caption: 'Documentos', component: <DocumentosBienes />, estado: 2 },
                    { id: 3, caption: 'Cancelación', component: <CancelacionBienes />, estado: 4 },
                ],
                selected: this.state.selected,
                load: true,
                cancelarOtrosi: this.props.cancelarBienes
            })

        break

        }

    }


	selectTab = (e, tab) => {
		e.preventDefault()
		this.setState({ selected: tab })
    }

    cancel = () => {
        this.props.showModalConfirmarAccion(true, `¿Está seguro que desea cancelar la solicitud?`, () => { this.props.showModalConfirmarAccion(false); this.state.cancelarOtrosi() })
    }


	render() {

		const { tabs, selected } = this.state
        const { estado, solicitud, user } = this.props
        //const esResponsableCompras = solicitud.getIn(['responsable_compras', 'id']) == user.get('id') || user.get('es_superusuario')
        const readOnly = !isAllowedToViewComponent('responsable_compras', solicitud)

        const boxActions = [
            <BoxButton key="ba[0][1]" name="floppy-o" title="Guardar" onClick={ () => this.props.updateSolicitudBI() } disabled={(this.props.tipo_solicitud != 6 && this.props.tipo_solicitud != 7) || estado > 1 || estado  == 0} />,
            <BoxButton key="ba[0][2]" name="ban" onClick={() => this.cancel()} title="Aprobar cancelación solicitud" disabled={ readOnly || selected !== 3 || estado == 0} />
        ]


		return (
            <div className="row" style={{ height: '100%', overflowX: 'hidden' }}>
                <div className="col-md-12" style={{ height: '100%' }}>
                    <div className="nav-container">
                        <div className="nav-tabs-section">
                            <ul className="nav-tabs-tabs">
                                {
                                    tabs.filter(x => {                                        

                                        if (solicitud.get('documentos') && x.id === 2 && solicitud.get('documentos').count() === 0) return null;

                                        if (estado == 7 && x.id == 3) return null;

                                        if (estado == 0) {                                            
                                            return (x.id == 0 || x.id == 3)
                                        }

                                        return true

                                    }).map(x => {
                                        return (
                                            <li key={ `li01[${x.id}]` } className={ selected === x.id ? 'active' : '' }>
                                                <a onClick={ (e) => this.selectTab(e, x.id) }>{ x.caption }</a>
                                            </li>
                                        )
                                    })
                                }
                            </ul>
                        </div>
                        <div className="nav-main-section">
                            <div className="">
                                <ButtonStrip actions={ boxActions } />
                            </div>
                            <div className="nav-main-section-scrollable">
                                { this.state.load && tabs[selected].component }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
		)
	}
}

function mapStateToProps(state) {
    return {
        estado: state.otrosi.get('estado'),
        solicitud: state.otrosi.get('solicitud'),
        tipo_solicitud: state.otrosi.getIn(['solicitud','documento_origen', 'solicitude', 'tipo'])
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getSolicitudOS: (id) => dispatch(getSolicitudOS(id)),
        getSolicitudServicioOT: (id) => dispatch(getSolicitudServicioOT(id)),
        getSolicitudServicio: (id) => dispatch(getSolicitudServicio(id)),
        getSolicitudBienes: (id) => dispatch(getSolicitudBienes(id)),
        updateSolicitudBI: () => dispatch(updateSolicitudBI()),
        cancelarServicio: () => dispatch(cancelarServicio()),
        cancelarServicioOT: () => dispatch(cancelarServicioOT()),
        cancelarBienes: () => dispatch(cancelarBienes()),
        showModalConfirmarAccion: (show, message, action) => dispatch(showModalConfirmarAccion(show, message, action)),
        getParameterByName: (nombre) => dispatch(getParameterByName(nombre)), 
    }
}



export default connect(mapStateToProps, mapDispatchToProps)(Otrosi)


// WEBPACK FOOTER //
// ./src/containers/Otrosi.jsx